// extracted by mini-css-extract-plugin
module.exports = {"item":"ServiceInfo_item__1gnsQ","status":"ServiceInfo_status__3jCcZ","title":"ServiceInfo_title__DREC7"};